import { TranRecordModel } from "./tran-record.model"

export class BuildTransactModel {
    ClientNo: number;
    ClinicNo: number;
    PetNo: number;
    LinkNo: number;
    LinkType: number;
    LinkName: string | null;
    LinkDesc: string | null;
    IndicationID: number | null;
    Category: string | null;
    LinkFix: string | null;
    Unit: number | null;
    UnitCost: number | null;
    Unit_Measure: string | null;
    Dosage: number | null;
    Route: string | null;
    Location: string | null;
    Frequency: string | null;
    Days: number | null;
    ReqDate: string | null;
    ReqBy: number | null;
    ReqName: string | null;
    Status: string | null;
    Price: number | null;
    SupSeq: number | null;
    Trans: TranRecordModel[] | null;
    intTotalIdx: number;
    intIndex: number;

    constructor(
        ClientNo: number = 0,
        ClinicNo: number = 0,
        PetNo: number = 0,
        LinkNo: number = 0,
        LinkType: number = 0,
        LinkName: string | null = null,
        LinkDesc: string | null = null,
        IndicationID: number | null = null,
        Category: string | null = null,
        LinkFix: string | null = null,
        Unit: number | null = null,
        UnitCost: number | null = null,
        Unit_Measure: string | null = null,
        Dosage: number | null = null,
        Route: string | null = null,
        Location: string | null = null,
        Frequency: string | null = null,
        Days: number | null = null,
        ReqDate: string | null = null,
        ReqBy: number | null = null,
        ReqName: string | null = null,
        Status: string | null = null,
        Price: number | null = null,
        SupSeq: number | null = null,
        Trans: TranRecordModel[] | null = null,
        intTotalIdx: number = 0,
        intIndex: number = 0
    ) {
        this.ClientNo = ClientNo;
        this.ClinicNo = ClinicNo;
        this.PetNo = PetNo;
        this.LinkNo = LinkNo;
        this.LinkType = LinkType;
        this.LinkName = LinkName;
        this.LinkDesc = LinkDesc;
        this.IndicationID = IndicationID;
        this.Category = Category;
        this.LinkFix = LinkFix;
        this.Unit = Unit;
        this.UnitCost = UnitCost;
        this.Unit_Measure = Unit_Measure;
        this.Dosage = Dosage;
        this.Route = Route;
        this.Location = Location;
        this.Frequency = Frequency;
        this.Days = Days;
        this.ReqDate = ReqDate;
        this.ReqBy = ReqBy;
        this.ReqName = ReqName;
        this.Status = Status;
        this.Price = Price;
        this.SupSeq = SupSeq;
        this.Trans = Trans;
        this.intTotalIdx = intTotalIdx;
        this.intIndex = intIndex;
    }
}
